import { useQuery } from "@apollo/client";
import { GET_INTEGRATION_SYNCHRONIZATION_QUERY } from "../../../apis/salesforce/queries";
import { HG_FORCE_CLIENT } from "../../../utils/consts";
import {
  GetIntegrationSynchronizationResponse,
  GetIntegrationSynchronizationVariables,
} from "../types";

export interface UseIntegrationSynchronizationOptions {
  skip?: boolean;
  pollInterval?: number;
  fetchPolicy?:
    | "cache-first"
    | "cache-and-network"
    | "network-only"
    | "cache-only"
    | "standby";
}

export const useIntegrationSynchronization = (
  integrationId?: string,
  options: UseIntegrationSynchronizationOptions = {}
) => {
  const { skip = false, pollInterval, fetchPolicy = "no-cache" } = options;

  const result = useQuery<
    GetIntegrationSynchronizationResponse,
    GetIntegrationSynchronizationVariables
  >(GET_INTEGRATION_SYNCHRONIZATION_QUERY, {
    variables: { integrationId },
    context: { clientName: HG_FORCE_CLIENT },
    skip: skip || !integrationId,
    pollInterval,
    fetchPolicy,
    errorPolicy: "all",
  });

  return {
    ...result,
    synchronization: result.data?.enrichmentSynchronization,
    synchronizationState: result.data?.enrichmentSynchronization?.state,
    startPolling: (pollInterval: number) => result.startPolling(pollInterval),
    stopPolling: () => result.stopPolling(),
  };
};
